import { Types } from '../constants/actionTypes';

const initialState = {
    event: false
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.UPDATE_PROMPT:
            return {
                ...state,
                event: event,
            }
        default:
            return state;
    }
}

export default reducer;